export default "__VITE_ASSET__$jLZTPIK__"